import React, { useMemo, useEffect, useState, MouseEvent } from 'react';
import { Box, IconButton, Paper, Popover, Typography } from '@mui/material';
import { Row } from 'react-table';
import FilterIcon from '../../../../assets/icons/filter-icon';
import useStyles from './styles';

type FilterProperties = {
  column: {
    filterValue: string[];
    setFilter: Function;
    preFilteredRows: Row[];
    id: string;
  };
};

export const SelectColumnFilter = (filterProperties: FilterProperties) => {
  const {
    column: { setFilter, preFilteredRows, id },
  } = filterProperties;
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(null);
  const [inputValue, setInputValue] = useState<string | null>('');
  const [checkFilter, setCheckFilter] = useState<string[]>([]);
  const classes = useStyles();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  const open = Boolean(anchorElement);
  const activeFilterColor = inputValue || checkFilter.length > 0 ? 'black' : undefined;
  const count = preFilteredRows.length;
  const options = useMemo(() => {
    const optionSet = new Set();
    preFilteredRows.forEach((row: any) => {
      optionSet.add(row.values[id]);
    });
    return [...optionSet.values()];
  }, [id, preFilteredRows]);

  useEffect(() => {
    if (checkFilter.length > 0) setFilter(checkFilter);
    if (checkFilter.length === 0) setFilter(null);
  }, [inputValue, checkFilter]);

  return <>
    <IconButton className={classes.iconButton} onClick={handleClick} size="large">
      <FilterIcon width="13px" height="13px" stroke={activeFilterColor} />
    </IconButton>
    <Popover
      id={id}
      open={open}
      anchorEl={anchorElement}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Paper>
        <Box p={1} pb={0}>
          <Typography>Filter {count} records...</Typography>
        </Box>
        <Box p={1} pb={0}>
          <input
            value={inputValue || ''}
            onChange={(event: any) => {
              setInputValue(event?.target?.value || null);
            }}
            placeholder="Narrow Filter Options"
          />
        </Box>
        <Box p={1}>
          <div className={classes.selectContainer}>
            {options
              .filter((option: any) =>
                inputValue !== '' && inputValue !== null ? option?.includes(inputValue) : true,
              )
              .map((option: any) => {
                const existsIndex = checkFilter.indexOf(option);
                return (
                  <div key={option}>
                    <input
                      type="checkbox"
                      onChange={() => {
                        if (existsIndex > -1) {
                          const checkFilterCopy = [...checkFilter];
                          checkFilterCopy.splice(existsIndex, 1);
                          setCheckFilter(checkFilterCopy);
                        } else setCheckFilter([...checkFilter, option]);
                      }}
                      checked={existsIndex > -1}
                    />
                    {option}
                  </div>
                );
              })}
          </div>
        </Box>
      </Paper>
    </Popover>
  </>;
};
